import { FormEvent, FormEventHandler, ReactNode } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';

import { FieldMessages } from '../common/helpers/getFinalFieldState.types';

import { WarningFormProvider } from './WarningFormProvider';

interface FormProps<T extends FieldValues> {
  onChange?: (event: FormEvent<EventTarget | HTMLFormElement>) => void;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  formContext: UseFormReturn<T> & { warnings?: FieldMessages };
  children: ReactNode;
}

function Form<T extends FieldValues>({
  children,
  onChange,
  onSubmit,
  formContext,
}: FormProps<T>) {
  return (
    <WarningFormProvider formContext={formContext as UseFormReturn<T>}>
      <form onChange={onChange} onSubmit={onSubmit} noValidate>
        {children}
      </form>
    </WarningFormProvider>
  );
}

export default Form;
